module.exports = __webpack_public_path__ + "img/property3.a7631b2c.png";